// API Configuration (Vite uses import.meta.env)
const API_URL = import.meta.env.VITE_API_URL || 'https://k7ocis6k3l.execute-api.us-east-1.amazonaws.com/prod';

export default API_URL;
